import { AddOutlined, DeleteOutline, EditOutlined } from '@mui/icons-material';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CustomButton, TableData } from '../../../components'
import { confirmAlert, errorAlert } from '../../../helpers/alerts';
import { getAlertsService, removeAlertService, updateAlertService } from 'services/admin/alertsService';
import { removeAlert, setAlerts, setCurrentAlert, updateAlert } from 'redux/slices/admin/alertSlice';
import moment from 'moment';
import { Box } from '@mui/material';

const TransactionsAlertsScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { alerts } = useSelector(store => store.alert);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true);
    getAlertsService("transaccional").then((result) => {
      dispatch(setAlerts(result))
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  const handlerClick = () => {
    navigate('crear')
  }

  const handlerEdit = (row) => {
    dispatch(setCurrentAlert(row));
    navigate("editar");
  };

  const handlerDelete = ({ id, name }) => {
    confirmAlert({
      title: "Estas seguro que deseas eliminar esta alerta?",
      text: `La alerta ${name} será eliminado.`,
      onConfirm: async () => {
        removeAlertService(id).then(() => {
          dispatch(removeAlert(id));
        }).catch(error => errorAlert(error))
      }
    })
  };

  const handlerCheck = async ({ id }, currentValue) => {
    const value = !currentValue;
    updateAlertService(id, { state: value }).then(({ state, updatedAt }) => {
      dispatch(updateAlert({ id, data: { state, updatedAt } }));
    }).catch(error => errorAlert(error))
  };

  return (
    <Box mt={-5}>
      <TableData
        dataRows={alerts}
        loading={loading}
        headerButtons={[
          <CustomButton
            icon={<AddOutlined />}
             sx={{ padding: '8px 16px' }}
            key="add"
            name={"Alerta"}
            click={handlerClick}
          />,
        ]}
        dataTitle={[
          "Nombre",
          "Tipo",
          "Transacciones",
          "Contacto",
          "Estado",
          "Activacion/Desactivacion"
        ]}
        formatter={({ name, txnState, txns, emails, numbers, state, updatedAt }) => [
          name,
          txnState === "approved" ? "APROBADAS" : "DENEGADAS",
          txns,
          {
            type: "text",
            value:
              (emails?.length ? emails?.join(" ") : "") +
              (numbers?.length ? "\n" + numbers?.join("\n") : ""),
            maxWidth: 100
          },
          { name: "state", type: "boolean", value: state },
          moment(updatedAt).format('DD/MM/YYYY HH:mm:ss '),
        ]}
        onChecked={handlerCheck}
        actions={[
          {
            label: "Editar",
            icon: <EditOutlined />,
            onClick: (data) => handlerEdit(data)
          },
          {
            label: "Eliminar",
            icon: <DeleteOutline />,
            onClick: (data) => handlerDelete(data)
          },
        ]}
      />
    </Box>
  )
}

export default TransactionsAlertsScreen